import React from 'react'
import { Link } from 'react-router-dom'
import CheckMarkIcon from 'custom/assets/icons/other/success'
import NeoButton from '../../components/NeoButton/NeoButton'
import { useTranslation } from 'react-i18next'
import { BUTTON_KEYS, BENEFICIARY_DOWNLOAD_KEYS } from '../../utils/translation-constants'

function NeoSuccess({ message, linkPath, onClick, onClick1, module = '', roleKey = ''  }) {
  const { t } = useTranslation()
  return (
    <div className='d-flex flex-column text-center bg-white'>
      <div className='row justify-content-center align-items-center'>
        <CheckMarkIcon height='200px' width='200px' />
      </div>
      <p className='mt-4 text-secondary'>{message}</p>
      {(module === 'DOWNLOAD_RECEIPT' && roleKey === 'AA') && (
        <div className='mt-4 mx-auto px-0 col-6'>
          <NeoButton onClick={onClick1} text={t(BENEFICIARY_DOWNLOAD_KEYS.DOWNLOAD_RECEIPT)} type='button' mode='newDesign' />
        </div>
      )}
      <div className='mt-4 mx-auto px-0 col-3'>
        <Link to={linkPath}>
          <NeoButton onClick={onClick} text={t(BUTTON_KEYS.DONE)} type='button' mode='newDesign'/>
        </Link>
      </div>
    </div>
  )
}

export default NeoSuccess
